import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { errorMessage, successMessage } from "../../utilities/notification";
import {
  RENDERED_IMAGE_LIST,
  RENDERED_IMAGE_SYNC,
  RENDERED_IMAGE_DETAIL,
} from "../actions/renderedimage.actions.types";

const call = Effects.call;

function* getRenderedImageList({ payload: { data, callback } }) {
  const payload = {
    params: { page: data.page },
    method: "get",
    url: "rendered-image/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* syncRenderedImage({ payload: { callback } }) {
  try {
    const payload = {
      method: "post",
      url: "rendered-images/sync",
    };

    const { error, result } = yield call(httpClient, {
      payload,
      isLoader: true,
      authorization: true,
    });

    if (error) {
      if (callback) {
        callback({ success: false, data: null });
      }
      return;
    }

    let authWindow = null;

    if (result?.data?.result?.authUrl) {
      authWindow = window.open(
        result.data.result.authUrl,
        "_blank",
        "width=900px,height=500px"
      );
    } else if (result?.data?.result?.images?.length) {
      successMessage("Images are syncing");
      if (callback) {
        callback({ success: true, data: result.data });
      }
    }
    if (authWindow) {
      const interval = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(interval);
          return;
        }
        try {
          const url = authWindow.location.href;
          if (url.includes("callback")) {
            successMessage(
              "Please try clicking the sync button again. You are now authenticated."
            );
            authWindow.close();
            if (callback) {
              callback({ success: true, data: result.data });
            }
          } else {
            errorMessage("Please try to reauthenticate.");
          }
        } catch (e) {}
      }, 1000);
    }
  } catch (error) {
    const message =
      error?.response?.data?.errors?.[0]?.message || "Something went wrong";
    errorMessage(message);
    if (callback) {
      callback({ success: false, data: null });
    }
  }
}

function* getRenderedImageDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `rendered-image/list/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* RenderedImage() {
  yield all([
    takeLatest(RENDERED_IMAGE_LIST, getRenderedImageList),
    takeLatest(RENDERED_IMAGE_SYNC, syncRenderedImage),
    takeLatest(RENDERED_IMAGE_DETAIL, getRenderedImageDetails),
  ]);
}

export default RenderedImage;
